import { useTranslation } from 'react-i18next'
import { Card, CardContent, CardHeader, TextField } from '@mui/material'
import UnitAdornment from '@component/UnitAdornment'
import AreaUnit from '@component/AreaUnit'
import { useFoundation } from './context'

function FoundationResult () {
  const { t } = useTranslation()
  const { form, result } = useFoundation()

  const hidden = !form.formState.isSubmitSuccessful

  const isHidden = (
    hidden
    || result === null
    || result === undefined
  )

  if (isHidden) return <></>

  const rcResult = `${(+result.criterionSize).toFixed(0)} x ${(+result.calculatedSizeForLateral).toFixed(0)}`

  return (
    <Card>
      <CardHeader title={t('COMPOUND.RESULT', { label: 'GLOSSARY.FOUNDATION' })} />
      <CardContent className="flex flex-col gap-16">
        <TextField
          label={t('GLOSSARY.THICKNESS')}
          disabled
          InputProps={{
            endAdornment: <UnitAdornment unit="mm" />,
          }}
          value={result.needHeight.toFixed(0)}
        />
        <TextField
          label={t('GLOSSARY.RATIO_VUPHIVC')}
          disabled
          value={result.finalRatio.toFixed(2)}
        />
        <TextField
          label={t('GLOSSARY.MIN_REQUIRED_LATERAL_AREA')}
          InputProps={{
            endAdornment: <UnitAdornment unit={<AreaUnit />} />,
          }}
          disabled
          type="text"
          value={rcResult}
        />
      </CardContent>
    </Card>
  )
}

export default FoundationResult
